// Helpers
import { privateApiUrl } from 'api/v3';

export function getIdeaBoardUrl(id, { include = ['hero_image', 'project'] } = {}) {
  return privateApiUrl(`idea_boards/${id}`, { include });
}
